import * as React from 'react';
import Auth from './Auth';

export const AuthContext = React.createContext(new Auth());